import isMobileAppRuntime from 'utils/isMobileAppRuntime';
import { updateOfflineState, getOfflineState } from './state';

let started = false;
let removeNativeListener = null;

const normalizeStatus = (status = {}) => ({
  connected: status.connected !== false,
  connectionType: status.connectionType || status.type || 'unknown',
});

export async function refreshNetworkStatus() {
  if (!isMobileAppRuntime()) {
    return updateOfflineState({
      connected: typeof navigator === 'undefined' ? true : navigator.onLine !== false,
      connectionType: 'browser',
    });
  }

  const network = window.Capacitor?.Plugins?.Network;
  if (network?.getStatus) {
    try {
      return updateOfflineState(normalizeStatus(await network.getStatus()));
    } catch (_) {}
  }

  return updateOfflineState({
    connected: typeof navigator === 'undefined' ? true : navigator.onLine !== false,
    connectionType: 'unknown',
  });
}

export async function startNetworkMonitor(onOnline) {
  if (started) return getOfflineState();
  started = true;

  const handleBrowser = async () => {
    const previous = getOfflineState().connected;
    const next = await refreshNetworkStatus();
    if (!previous && next.connected && typeof onOnline === 'function') onOnline();
  };

  window.addEventListener('online', handleBrowser);
  window.addEventListener('offline', handleBrowser);

  const network = window.Capacitor?.Plugins?.Network;
  if (isMobileAppRuntime() && network?.addListener) {
    try {
      const listener = await network.addListener('networkStatusChange', (status) => {
        const previous = getOfflineState().connected;
        const next = updateOfflineState(normalizeStatus(status));
        if (!previous && next.connected && typeof onOnline === 'function') onOnline();
      });
      removeNativeListener = () => listener?.remove?.();
    } catch (_) {}
  }

  return refreshNetworkStatus();
}

export function stopNetworkMonitor() {
  try { removeNativeListener?.(); } catch (_) {}
  removeNativeListener = null;
  started = false;
}
